// Integração Vue-side do boot splash (markup/estilo em public/index.html +
// public/boot-splash.{css,js}). Responsável por:
//  1. sincronizar o cache da marca usado pelo splash (com regra anti-vazamento);
//  2. remover o splash com fade depois que o app monta.
// O `store` é injetado pelo chamador (main.js) para evitar acoplamento/ciclo de
// import e facilitar teste.

// Sincroniza o cache do boot splash com a marca do escritório.
// REGRA ANTI-VAZAMENTO: só cacheia para usuários NÃO internos. Usuários internos
// (CS/admin) acessam vários escritórios pelo admin SEM logout — cachear vazaria a
// marca do escritório anterior no próximo boot. Para eles, limpamos o cache, então
// o splash fica neutro e a marca correta vem só do CinematicLoader (pós-config).
export function syncBootSplashCache(store) {
  try {
    const user = store.getters['user/currentUser'] || {}
    if (user.IS_INTERNAL) {
      window.localStorage.removeItem('aawz_boot')
      return
    }
    const colors = store.getters['parameters/colors'] || {}
    window.localStorage.setItem(
      'aawz_boot',
      JSON.stringify({
        bg: colors['bg-navbar-header'] || '#FFFFFF',
        primary: colors['primary'] || '#56AF79',
        logo: store.getters['parameters/logo'] || '',
      })
    )
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Boot splash: falha ao sincronizar cache no localStorage', e)
  }
}

// Dispara o sync assim que o usuário carrega (após o getCurrentUser do router),
// quando IS_INTERNAL já está disponível. Observa uma única vez.
export function setupBootSplashSync(store) {
  let unwatch = null
  const handle = (user) => {
    if (!user || user.loading) {
      return
    }
    syncBootSplashCache(store)
    if (unwatch) {
      unwatch()
    }
  }
  unwatch = store.watch(
    () => store.getters['user/currentUser'],
    handle,
    { immediate: true }
  )
}

// Faz o fade-out do boot splash (overlay irmão de #app no index.html) depois que
// o app montou e pintou por baixo, removendo-o do DOM. Dois rAF garantem que o
// CinematicLoader já pintou antes do fade (cross-fade imperceptível).
export function hideBootSplash() {
  const splash = document.getElementById('aawzBoot')
  if (!splash) {
    return
  }
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      splash.classList.add('aawzBootLeaving')
      setTimeout(() => {
        splash.remove()
      }, 500)
    })
  })
}
